export default __webpack_public_path__ + "static/media/my_team_insights_theme_logo.e4b23cee.png";